import { Doughnut } from 'react-chartjs-2'

import { ChartWrapper } from './styled'

type Item = {
  name: string
  count: number
}

type Props = {
  data: Item[]
}

export function ContestByStatus({ data }: Props): JSX.Element {
  return (
    <ChartWrapper>
      <Doughnut
        options={
          {
            responsive: true,
            plugins: {
              title: {
                display: false
              },
              legend: {
                display: false
              },
              colorschemes: {
                scheme: 'brewer.Paired12'
              }
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          } as any
        }
        data={{
          labels: data.map(({ name }) => name),
          datasets: [
            {
              data: data.map(({ count }) => count),
              backgroundColor: ['#159F9F', '#FFE399', '#3FA73A']
            }
          ]
        }}
      />
    </ChartWrapper>
  )
}
